import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

import classnames from 'classnames'

import useRequestPending from 'shared/hooks/useRequestPending'

import { getSubscriptionsHistory, getWaitList } from 'dashboard-subscriptions/actions'
import SubscriptionModal from 'dashboard-subscriptions/components/SubscriptionModal'
import {
    SUBSCRIPTION_STATUSES,
    SUBSCRIPTION_STATUS_ACTIVE,
    SUBSCRIPTION_STATUS_CANCELLED,
    SUBSCRIPTION_STATUS_WAITING,
} from 'dashboard-subscriptions/constants'
import {
    getWaitListSelectorPendingSelector,
    subscriptionsHistoryPendingSelector,
    subscriptionsHistorySelector,
    waitListSelector,
} from 'dashboard-subscriptions/selectors'

import CircleLoader from '@components/CircleLoader'

import getHeader from './getHeader'
import SubscriptionsList from './SubscriptionsLists'
import WaitList from './WaitList'

import styles from './styles.module.scss'

const useInitialStatus = () => {
    const { list } = useParams()

    switch (list) {
        case 'waitinglist':
            return SUBSCRIPTION_STATUS_WAITING
        default:
            return SUBSCRIPTION_STATUS_ACTIVE
    }
}

const SubscriptionsView = ({
    getSubscriptionsHistory,
    subscriptions,
    subscriptionsPending,
    waitList,
    getWaitListPending,
    getWaitList,
}) => {
    const intialStatus = useInitialStatus()

    const [selectedTab, setSelectedTab] = useState(intialStatus)
    const [selectedSubscription, setSelectedSubscription] = useState(null)
    const getPending = () => {
        switch (selectedTab) {
            case SUBSCRIPTION_STATUS_CANCELLED:
            case SUBSCRIPTION_STATUS_ACTIVE:
                return subscriptionsPending
            case SUBSCRIPTION_STATUS_WAITING:
                return getWaitListPending
        }
    }

    const { isLoading } = useRequestPending(getPending())

    useEffect(() => {
        getSubscriptionsHistory()
        getWaitList()
    }, [])

    const openSubscription = (index, initialTab) => {
        setSelectedSubscription({ index, initialTab })
    }

    const getList = () => {
        switch (selectedTab) {
            case SUBSCRIPTION_STATUS_CANCELLED:
            case SUBSCRIPTION_STATUS_ACTIVE:
                return (
                    <SubscriptionsList
                        subscriptions={subscriptions}
                        openSubscription={openSubscription}
                        selectedTab={selectedTab}
                    />
                )
            case SUBSCRIPTION_STATUS_WAITING:
                return <WaitList waitList={waitList} />
        }
    }

    return (
        <>
            {selectedSubscription != null && (
                <SubscriptionModal
                    onClose={() => setSelectedSubscription(null)}
                    id={subscriptions[selectedSubscription?.index].id}
                    initialTab={selectedSubscription?.initialTab}
                />
            )}
            <div className="container dashboard-inner-container">
                <div className={styles.tabs}>
                    {SUBSCRIPTION_STATUSES.map((tab, index) => (
                        <div
                            className={tab === selectedTab && styles.selected}
                            key={index}
                            onClick={() => setSelectedTab(tab)}>
                            <T>{`dashboard.subscriptions.tab.${tab.toLowerCase()}`}</T>
                        </div>
                    ))}
                </div>

                <div className={classnames('table', 'table-hover', 'mt-5', styles.table, styles.subscriptions)}>
                    {getHeader(selectedTab)}
                    {isLoading ? (
                        <div className="d-flex justify-content-center mt-4 pb-4">
                            <CircleLoader />
                        </div>
                    ) : (
                        getList()
                    )}
                </div>
            </div>
        </>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            subscriptionsPending: subscriptionsHistoryPendingSelector,
            subscriptions: subscriptionsHistorySelector,
            getWaitListPending: getWaitListSelectorPendingSelector,
            waitList: waitListSelector,
        }),
        { getSubscriptionsHistory, getWaitList }
    )
)(SubscriptionsView)
